<template>
  <b-container fluid class="p-0">
    <b-row>
      <b-col cols="2" md="1">
        <div v-if="product.imported_country" class="text-center">
          <flag :iso="product.imported_country" :squared="false" class="product-flag" />
          {{ product.imported_country }}
        </div>
      </b-col>
      <b-col cols="10" md="4">
        <p class="product-name">
          <router-link :to="productRoute">{{ product.description }}</router-link>
        </p>
        <span v-for="(substance, index) in product.substances" :key="index">{{ substance.description }}. </span>
      </b-col>
      <b-col cols="12" md="3">
        <p class="price">
          <span v-if="price">{{ $formatMoney(price, currency) }}</span>
        </p>
        <div v-if="discount" class="mb-4 mb-md-0">
          <div class="discount-type mb-2">
            ({{ $t("wide_product_card.pack_offer") }} x{{ discountPackQuantity }})
          </div>
          <span class="no-discount-price mr-2">
            {{ $formatMoney(priceBefore, currency) }}
          </span>
          <span class="discount-box p-2">
            -{{ discountPercent }}%
          </span>
        </div>
      </b-col>
      <b-col cols="12" md="4">
        <vue-element-loading :active="to_cart_loading" />
        <b-button
          variant="cart"
          class="buy-button mr-2"
          :disabled="!price"
          @click="buyProduct()"
        >{{ $t('wide_product_card.add') }}</b-button>
        <b-button
          variant="buy"
          :disabled="!price"
          @click="buyProduct(1, true)"
        >
          {{ $t('wide_product_card.buy') }}
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>


<script>
import { ProductCardMixin } from "@/mixins/ProductCardMixin";

export default {
  name: "wide-product-card",
  mixins: [ProductCardMixin],
  fallbackI18n: {
    messages: {
      und: {
        wide_product_card: {
          add: "Add",
          buy: "Buy",
          see_more: "See more",
          pack_offer: "Pack Offer",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.price {
  font-size: $font-size-base * 1.1;
  font-weight: bold;
}

.product-name {
  font-size: $font-size-base * 1.1;
  font-weight: bold;

  a {
    color: $text-main-color;
    text-decoration: none;
  }
}

.buy-button {
  width: 40%;
}

.see-more-button {
  background-color: $grey3-color;
  border-radius: 0;
  color: white;
  font-size: $font-size-base * 0.8;
  font-weight: bold;
  text-decoration: none;
  padding: 0.5rem 0.1rem;
  width: 40%;
}

.see-more-button:hover {
  color: white;
}

.discount-type {
  color: $grey5-color;
}

.no-discount-price {
  color: $grey5-color;
  font-size: $font-size-medium * 1.1;
  font-weight: bold;
  text-decoration: line-through;
}

.discount-box {
  background-color: $discount-bg-color;
  color: $white;
  font-size: $font-size-medium * 1.1;
  font-weight: bold;
}

.product-flag {
  font-size: $font-size-medium * 1.5;
}
</style>
